export const DEVICE_TYPE_OPTIONS = [
	{ id: 'IOS', label: 'IOS' },
	{ id: 'ANDROID', label: 'ANDROID' }
];

export enum EConfigUpdateURL {
	GET_DEFAULT_VALUE_FOR_KEY = '/dashboard/getDefaultValueForKey/gameAdmin-zkDashBoardUpdate-getDefaultValueForKey',
	UPDATE_ZK_KEY_PARTIALLY = '/dashboard/updateZkKeyPartially/gameAdmin-zkDashBoardUpdate-updateZkKeyPartially',
	PROMOTE_TO_PROD_DIRECTLY = '/dashboard/promoteToProdDirectly/gameAdmin-zkDashBoardUpdate-promoteToProdDirectly'
}

export enum EConfigUpdateURLQueryParams {
	serviceName = 'SUPERAPP.SERVICE',
	game = 'ludo',
	key = 'in.ludo.supremegold'
}
